<template>
  <v-dialog
    v-model="dialogConsultaProspectosFinalizados.estatus"
    hide-overlay
    persistent
    max-width="800"
  >
    <v-card>
      <v-card-title primary-title>
        Consultar Prospectos Finalizados
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col cols="12" md="6" lg="4">
            <v-text-field
              v-model="telefono"
              dense
              hide-details
              filled
              type="text"
              label="Teléfono"
              clearable
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="6" lg="4">
            <v-text-field
              v-model="folio"
              dense
              hide-details
              filled
              type="text"
              label="Folio"
              clearable
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="6" lg="4" class="d-flex align-center">
            <v-btn color="primary" @click="buscarProspectos">
              Buscar
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-text>
        <v-data-table
          :headers="headersProspectos"
          :items="prospectos"
          class="elevation-0"
          dense
        >
          <template v-slot:item.usuario_asignado="{ item }">
            {{ item.usuario_asignado_nombre }}
          </template>
          <template v-slot:item.usuario_creo="{ item }">
            {{ item.usuario_creo_nombre }}
          </template>
          <template v-slot:item.idalumno="{ item }">
            {{ item.idalumno_nombre_completo }}
          </template>
        </v-data-table>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" dark @click="dialogConsultaProspectosFinalizados.estatus = false">
          Cancelar
        </v-btn>
      </v-card-actions>

      <v-btn
        color="transparent elevation-0"
        x-small
        absolute
        top
        right
        fab
        class="mt-5 mr-0"
        @click="dialogConsultaProspectosFinalizados.estatus = false"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card>

    <!-- Dialog de carga -->
    <Alerta v-if="respuestaAlerta" :parametros="parametros"/>
    <carga v-if="cargar"/>
  </v-dialog>
</template>

<script>
import Alerta from '@/components/alertas/Alerta.vue';
import carga from '@/components/alertas/carga.vue';
import validarErrores from '@/mixins/validarErrores';

export default {
  components: { Alerta, carga },
  mixins: [validarErrores],
  props: ['dialogConsultaProspectosFinalizados'],
  data: () => ({
    parametros: { dialogError: false, mensaje: '', color: '' },
    respuestaAlerta: false,
    cargar: false,
    telefono: '',
    folio: '',
    prospectos: [],
    headersProspectos: [
      { text: 'Usuario Asignado', value: 'usuario_asignado_nombre' },
      { text: 'Usuario Creó', value: 'usuario_creo_nombre' },
      { text: 'Estatus', value: 'estatus' },
      { text: 'Teléfono', value: 'telefono' },
      { text: 'Folio', value: 'folio' },
      { text: 'Sucursal Interés', value: 'sucursal_interes' },
      { text: 'Fecha Creación', value: 'fecha_creacion' },
      { text: 'Id Alumno', value: 'idalumno_nombre_completo' },
      { text: 'Escuela', value: 'escuela' },
    ],
  }),
  methods: {
    async buscarProspectos() {
      this.cargar = true;
      this.prospectos = [];
      try {
        const response = await this.$http.post('obtener.prospectos.finalizados', {
          telefono: this.telefono,
          folio: this.folio
        });
        this.prospectos = response.data
      } catch (error) {
        console.error(error);
        this.validarError( error.response.data.message )
      } finally {
        this.cargar = false;
      }
    }
  }
};
</script>
